const ElementType = {
  Text: 12,
  Image: 13,
  Input: 10,
  Icon: 9,
  Button: 8,
  File: 14,
  Alert: 7,
  Link: 11,
  Line: 15,
}

Object.freeze(ElementType)

export default ElementType
